import React, { FC, useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { IconButton } from '@eika/button';
import { IconTypes } from '@eika/icon';
import { Input, InputLabel } from '@eika/input';
import { ErrorLabel } from '@eika/label';

import { useTranslation } from '../../translations';

export type NedbetalingstidFormData = {
    nedbetalingstid: number;
};

const Nedbetalingstid: FC = () => {
    const { laanebeloep, validationMessage, button } = useTranslation();
    const {
        register,
        control,
        setValue,
        formState: { errors },
        clearErrors,
    } = useFormContext<NedbetalingstidFormData>();
    const nedbetalingstid = useWatch({ name: 'nedbetalingstid', control }) || 0;

    useEffect(() => {
        if (nedbetalingstid > 30) {
            setValue('nedbetalingstid', 30);
        } else if (nedbetalingstid <= 0) {
            setValue('nedbetalingstid', 0);
        }
    }, [nedbetalingstid, setValue]);

    const onClickPlus = () => {
        clearErrors('nedbetalingstid');
        setValue('nedbetalingstid', nedbetalingstid === 30 ? 30 : nedbetalingstid + 1);
    };

    const onClickMinus = () => {
        clearErrors('nedbetalingstid');
        setValue('nedbetalingstid', nedbetalingstid === 1 ? 1 : nedbetalingstid - 1);
    };

    return (
        <div>
            <InputLabel label={laanebeloep.labelNedbetalingstid} />
            <div className="nedbetalingstid">
                <IconButton
                    icon={IconTypes.MINUS_36}
                    screenReaderText={button.iconButtonMinus}
                    onClick={onClickMinus}
                />
                <Input
                    inputMode="numeric"
                    type="number"
                    maxLength={2}
                    className="max-width-100 center-input"
                    {...register('nedbetalingstid', {
                        valueAsNumber: true,
                        validate: { largerThanZero: (value: number) => value > 0 && value <= 30 },
                        required: `${validationMessage.nedbetalingsTidValue}`,
                    })}
                />
                <IconButton icon={IconTypes.PLUSS_36} screenReaderText={button.iconButtonPlus} onClick={onClickPlus} />
            </div>
            <div className="padding-top-small">
                {errors.nedbetalingstid && <ErrorLabel text={validationMessage.nedbetalingsTidValue} />}
            </div>
        </div>
    );
};

export default Nedbetalingstid;
